
<shared-header [icons]="icons"></shared-header>

<div class="hero-main">

  <img class="hero-sphere-1" src="{{ icons.sphere1 }}" alt="">
  <img class="hero-sphere-2" src="{{ icons.sphere1 }}" alt="">

  <div class="left-container">

    <!-- <prestamo-bar
      [icono]="icons.money"
      [texto]="'Préstamo para negocios'">
    </prestamo-bar> -->

    <div class="prestamo-description">
      <p>Haz posible ese proyecto, </p>
      <p>Nosotros te ayudamos</p>
    </div>

    <button-credito
      [texto]="'Solicitar crédito'"
      [icono]="icons.buttonCircle"
    ></button-credito>

  </div>
  <div class="right-container">

      <!-- animacion hero -->
      <ng-lottie
        ngClass="hero-animation"
        [options]="loaderPerfilador"
        #lott>
      </ng-lottie>

  </div>

  <div class="hero-footer">
    <div class="footer-logos">
      <span>Supervisada por:</span>
      <div style="display: flex; gap: 32px;">
        <!-- (click)="downloadPDF('condusef')" -->
        <!-- (click)="downloadPDF('banxico')" -->
        <!-- (click)="downloadPDF('buro')" -->
        <img src="{{ icons.logoCondusef }}" alt="Condusef"
            style="cursor:pointer;">
        <img src="{{ icons.logoBanxico }}" alt="Banxico"
            style="cursor:pointer;">
      </div>
    </div>

    <div class="footer-logos">
      <span>Registrada ante:</span>
      <img src="{{ icons.logoBuro }}" alt="Buró"
          style="cursor:pointer;">
    </div>
  </div>

  <img class="hero-sphere-3" src="{{ icons.sphere3 }}" alt="">

</div>
        <img class="whatsapp-icon" src="{{ icons.whatsapp }}" alt=""
        [ngStyle]=" {
          'width': '84px',
          'height': '84.287px',
          'position': 'fixed',
          'right': '48px',
          'bottom': '25px',
          'z-index': 1000,
          'cursor': 'pointer'
        }"
        (click)="openWhatsApp()">




